import {
  UPLOAD_CONTENT_REQUEST, UPLOADING_CONTENT_PROGRESS,
  CREATE_CONTENT_REQUEST, CREATING_CONTENT_SUCCEEDED, CREATING_CONTENT_FAILED, UPDATE_ASSETS_CONTENT, UPDATE_MULTIPLE_ASSETS_CONTENT,
  ADD_ASSET_URL, ADD_ASSET_URL_SUCCEDDED, ADD_ASSET_URL_FAILED, INVALIDATE_ASSET_UPLOADED, DELETE_ASSET_REQUEST,
  CREATE_ASSET_MAPPING_REQUEST, CREATING_ASSET_MAPPING_SUCCEEDED, CREATING_ASSET_MAPPING_FAILED,
  FETCH_ASSET_MAPPINGS_REQUEST, FETCHING_ASSET_MAPPINGS_SUCCEEDED, FETCHING_ASSET_MAPPINGS_FAILED,
  DELETE_ASSET_MAPPINGS_REQUEST, DELETING_ASSET_MAPPINGS_SUCCEEDED, DELETING_ASSET_MAPPINGS_FAILED,
  UPDATE_ASSET_MAPPING_REQUEST, UPDATING_ASSET_MAPPING_SUCCEEDED, UPDATING_ASSET_MAPPING_FAILED,
  UPDATE_ASSET_MAPPINGS_REQUEST, UPDATING_ASSET_MAPPINGS_SUCCEEDED, UPDATING_ASSET_MAPPINGS_FAILED,

  FETCH_PREVIEW_FOR_ASSET_REQUEST, FETCHING_PREVIEW_FOR_ASSET_SUCCEEDED, FETCHING_PREVIEW_FOR_ASSET_FAILED,
  FETCH_DUPLICATE_ASSETS_REQUEST, FETCHING_DUPLICATE_ASSETS_SUCCEEDED, FETCHING_DUPLICATE_ASSETS_FAILED, INVALIDATE_DUPLICATE_ASSETS,
  FETCH_PREVIEW_TEXT_FOR_ASSET_REQUEST, FETCHING_PREVIEW_TEXT_FOR_ASSET_SUCCEEDED, FETCHING_PREVIEW_TEXT_FOR_ASSET_FAILED,

  CREATE_ASSET_VERSION_REQUEST, CREATING_ASSET_VERSION_SUCCEEDED, CREATING_ASSET_VERSION_FAILED,
  UPDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER, INVALIDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER,
  
  FETCH_ASSET_MAPPINGS_ON_SEARCH_REQUEST, FETCHING_ASSET_MAPPINGS_ON_SEARCH_SUCCEEDED, FETCHING_ASSET_MAPPINGS_ON_SEARCH_FAILED, 
  INVALIDATE_SEARCH_ASSET_MAPPINGS,
  
  UPLOADING_ASSET_VERSION_PROGRESS, UPLOADING_ASSET_VERSION_STARTED, 
  UPLOAD_ASSET_REQUEST, REMOVE_ASSET_REQUEST,
  INVALIDATE_ASSET_MAPPINGS, INVALIDATE_ASSET_SELECTION,
  ASSET_SEEK_INDEXING_REQUEST,
  ASSET_SEEK_INDEXING_SUCCEEDED,
  ASSET_SEEK_INDEXING_FAILED,
  FETCH_ASSET_MAPPING_REQUEST,
  FETCHING_ASSET_MAPPING_SUCCEEDED,
  FETCHING_ASSET_MAPPING_FAILED
} from 'constants/actionTypes';

import { call, put, takeEvery, select, all } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import _, { identity } from 'lodash';
import buildUrl from 'build-url';
import FileService from 'services/file.service';
import { createMixpanelEvent } from "actions/mixpanel";
import { getStoryboardMixpanelEventPayload } from 'services/mixpanelUtil';
import { MIXPANEL_ASSET_UPLOADED } from "constants/mixpanelEvents";

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const paperfliteApiUrl = process.env.REACT_APP_PAPERFLITE_API_URL;

const ASSETS_BASE_URL = `${paperfliteApiUrl}/api/2.0/assets`;
const ASSET_MAPPING_BASE_URL = `${cleverstoryApiUrl}/api/2.0/content-mappings`;
const FILE_UPLOAD_BASE_URL = `${paperfliteApiUrl}/api/2.0/file_upload`;
const SEEK_INDEXING_URL = `${cleverstoryApiUrl}/api/2.0/cleverstory/seek/index`;

/*
* Create Asset from url
*/
export const createAssetFromUrl = createAction(ADD_ASSET_URL, (request) => {
  return request;
})

const creatingAssetFromUrlSuccedded = createAction(ADD_ASSET_URL_SUCCEDDED, (url, json) => {
  return {
    asset: json,
    url: url
  }
})

const creatingAssetFromUrlFailed = createAction(ADD_ASSET_URL_FAILED, (url, error) => {
  return {
    error: error,
    url: url
  }
})

function* createAssetFromUrlSaga(action) {
  const storyboard = yield select(state => _.get(state, "storyboards.storyboard.item", null));

  const request = action.payload;

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: `/url`
  });

  const createAssetFromUrlAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(createAssetFromUrlAPI);
    if (response) {
      yield put(creatingAssetFromUrlSuccedded(request.url, response));
    }
  } catch (error) {
    yield put(creatingAssetFromUrlFailed(request.url, error));
  }
}

/*
* Create Asset from presigned s3 file
*/
export const createContent = createAction(CREATE_CONTENT_REQUEST, (url, file) => {
  return {
    file: file,
    url: url
  }
})

const creatingContentSucceeded = createAction(CREATING_CONTENT_SUCCEEDED, (url, file, json) => {
  return {
    asset: json,
    url: url,
    file: file
  }
})

const creatingContentFailed = createAction(CREATING_CONTENT_FAILED, (url, file, error) => {
  console.log(error);
  return {
    error: error,
    url: url,
    file: file
  }
});

function* createContentSaga(action) {
  const creatingAssetAPI = () => {
    var data = {
      signedUrl: action.payload.url
    }
    return axios.post(
      FILE_UPLOAD_BASE_URL,
      data
    ).then((response) => {
      return response.data;
    })
      .catch(err => {
        throw err;
      });
  }

  try {
    const response = yield call(creatingAssetAPI);
    if (response) {
      yield put(creatingContentSucceeded(action.payload.url, action.payload.file, response));

      const storyboard = yield select(state => _.get(state, "storyboards.storyboard.item.id", null));

      let request = {
        storyboard: storyboard,
        assets: [response.id]
      }
      //yield put(createAssetMapping(request));  //remove this and call the action on (add & close) of upload.
    }
  } catch (error) {
    console.log(error);
    yield put(creatingContentFailed(action.payload.url, action.payload.file, error));
  }
}

/*
* Update multiple Asset from presigned s3 file
*/

export const updateMultipleContent = createAction(UPDATE_MULTIPLE_ASSETS_CONTENT, (selectedId, fieldType, request, multiSelect) => {

  return {
    selectedId: selectedId,
    fieldType: fieldType,
    request: request,
    multiSelect: multiSelect,
  }
})

function* updateMultipleContentSaga(action) {

  const { selectedId, fieldType, request, multiSelect } = action.payload;
  const assetContents = yield select(state => _.get(state, `content.assets`) || []);
  const selectedContent = _.filter(assetContents, (asset) => { return _.includes(selectedId, asset.id) });

  const updatedContent = _.map(selectedContent, (content) => {
    if (fieldType === 'tags') {
      const existingTags = _.get(content, 'tags') || [];
      const { value: newTags, addedTags, removedTags, action } = request;
      
      let finalTags;
      
      if (action === 'remove' && removedTags.length > 0) {
        finalTags = existingTags.filter(tag => !removedTags.includes(tag));
      } else if (action === 'add' && addedTags.length > 0) {
        finalTags = _.uniq([...existingTags, ...addedTags]);
      } else {
        finalTags = newTags;
      }
      
      return {
        ...content,
        [fieldType]: finalTags,
        asset: {
          ...content.asset,
          [fieldType]: finalTags
        }
      }
    }

    if (['disableDownload', 'disableShare', 'excludeFromSearch', 'csInternalAsset'].includes(fieldType)) {
      const fieldValue = request.hasOwnProperty('value') ? request.value : request;
      
      return {
        ...content,
        [fieldType]: fieldValue,
        asset: {
          ...content.asset,
          [fieldType]: fieldValue
        }
      }
    }

    if (fieldType === 'customFields') {
      let customFields = _.get(content, 'customFields') || [];
      const { fieldId, addedValues, removedValues, action } = request;

      if (action === 'remove' && removedValues.length > 0) {
        customFields = customFields.map(field => {
          if (field.id === fieldId) {
            const updatedValues = field.value.filter(val => 
              !removedValues.some(removedVal => removedVal.id === val.id)
            );
            return {
              ...field,
              value: updatedValues
            };
          }
          return field;
        }).filter(field => field.value.length > 0);
      } else if (action === 'add' && addedValues.length > 0) {
        const fieldIndex = customFields.findIndex(field => field.id === fieldId);
        
        if (fieldIndex !== -1) {
          const currentValues = customFields[fieldIndex].value || [];
          const updatedValues = _.uniqBy([...currentValues, ...addedValues], 'id');
          customFields[fieldIndex] = {
            ...customFields[fieldIndex],
            value: updatedValues
          };
        } else {
          const newFieldData = request.value.find(cf => cf.id === fieldId);
          if (newFieldData) {
            customFields.push(newFieldData);
          }
        }
      } else {
        _.forEach(request.value, data => {
          const matchingField = customFields.find(customField => customField.id === data.id);
          if (matchingField) {
            _.forEach(customFields, (field, index) => {
              if (field.id === matchingField.id && multiSelect) {
                var updated = [...field.value, ...data.value];
                updated = _.uniqBy(updated, 'id');
                customFields[index] = {
                  ...field,
                  value: updated
                };
              }
              if (field.id === matchingField.id && !multiSelect) {
                customFields[index] = {
                  ...field,
                  value: data.value
                };
              }
            });
          } else {
            customFields.push(data);
          }
        });
      }

      return {
        ...content,
        customFields: customFields
      }
    }

    const fieldValue = request.hasOwnProperty('value') ? request.value : request;
    
    return {
      ...content,
      asset: {
        ...content.asset,
        [fieldType]: fieldValue
      }
    }
  })

  for (const data of updatedContent) {
    yield put(updateContent(data.id, data));
  }
}

/*
* Update Asset from presigned s3 file
*/

export const updateContent = createAction(UPDATE_ASSETS_CONTENT, (id, request) => {
  return {
    id: id,
    request: request
  }
})

export const uploadingContent = createAction(UPLOAD_CONTENT_REQUEST, (file) => {
  return {
    file: file
  }
})

/*
* Track file upload to s3
*/
export const uploadingContentProgress = createAction(UPLOADING_CONTENT_PROGRESS, (file, progress) => {
  return {
    progress: progress,
    file: file
  }
});


/*
* Create Asset mapping for assets
*/
export const createAssetMapping = createAction(CREATE_ASSET_MAPPING_REQUEST, (request) => {
  return {
    request: request
  }
});

const createAssetMappingSucceeded = createAction(CREATING_ASSET_MAPPING_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  }
});

const createAssetMappingFailed = createAction(CREATING_ASSET_MAPPING_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  }
});

function* createAssetMappingSaga(action) {
  const { request } = action.payload;

  const createAssetMappingAPI = () => {
    return axios.post(ASSET_MAPPING_BASE_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createAssetMappingAPI);
    if (response) {
      yield put(createAssetMappingSucceeded(request, response));

      const fetchDuplicateAssetsSagas = response.map(record =>
        put(fetchDuplicateAssetsRequest(record))
      )

      yield all(fetchDuplicateAssetsSagas);
      
      yield put(fetchAssetMappings({storyboard: request.storyboard}, 0))
      const storyboard = yield select(state => _.get(state, "storyboards.storyboard.item", null));
      for (const asset of response) {
        const metaData = _.get(asset, 'asset.metadata', null);
        const contentType = FileService.fileType(metaData);
        if (contentType) {
          const typesToCapitalize = ["IMAGE", "VIDEO", "DOCX", "DOC", "LINK", "AUDIO"];
          const typesToLink = ["INTERACTIVE", "SPATIAL", "LANDING_PAGE", "RESOURCE_CENTER", "FLIP_BOOK"];
          const formattedContentType = typesToCapitalize.includes(contentType)
          ? contentType.charAt(0).toUpperCase() + contentType.slice(1).toLowerCase()
          : typesToLink.includes(contentType) ? "Link" : contentType;
          var storyboardId = _.get(storyboard, 'id', '');
          var storyboardName = _.get(storyboard, 'name', '');
          var storyboardType = _.get(storyboard, 'type', '');
          var mixpanelPayload = getStoryboardMixpanelEventPayload(storyboardId, storyboardName, storyboardType);
          mixpanelPayload = {
          ...mixpanelPayload,
          asset_type: formattedContentType,
          }
      yield put(createMixpanelEvent(MIXPANEL_ASSET_UPLOADED, mixpanelPayload));
    }
  }}
  } catch (error) {
    yield put(createAssetMappingFailed(request, error));
  }
}

/*
*  Fetching asset mappings for storyboard
*/
export const fetchAssetMappings = createAction(FETCH_ASSET_MAPPINGS_REQUEST, (request, page, limit = 20, requestId) => {
  return {
    request: request,
    page: page,
    limit: limit,
    requestId: requestId
  }
})

const fetchingAssetMappingsSucceeded = createAction(FETCHING_ASSET_MAPPINGS_SUCCEEDED, (request, response, requestId) => {
  return {
    request: request,
    response: response,
    requestId: requestId
  };
})

const fetchingAssetMappingsFailed = createAction(FETCHING_ASSET_MAPPINGS_FAILED, (error) => {
  return error;
})

function* fetchAssetMappingsSaga(action) {
  const { request, page, limit, requestId } = action.payload;

  const params = {
    page: page,
    limit: limit
  };

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: 'search',
    queryParams: params
  });

  const fetchAssetMappingsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchAssetMappingsAPI);
    if (response) {
      yield put(fetchingAssetMappingsSucceeded(request, response, requestId));
    }
  } catch (error) {
    yield put(fetchingAssetMappingsFailed(error));
  }
}


/*
*  Fetching asset mapping for assetmapping id
*/
export const fetchAssetMapping = createAction(FETCH_ASSET_MAPPING_REQUEST, (id, storyboard) => {
  return {
    id: id,
    storyboard: storyboard
  }
})

const fetchingAssetMappingSucceeded = createAction(FETCHING_ASSET_MAPPING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
})

const fetchingAssetMappingFailed = createAction(FETCHING_ASSET_MAPPING_FAILED, (error) => {
  return error;
})

function* fetchAssetMappingSaga(action) {
  const { id, storyboard } = action.payload;

  const params = {
    storyboard: storyboard,
  };

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: id,
    queryParams: params
  });

  const fetchAssetMappingsAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchAssetMappingsAPI);
    if (response) {
      yield put(fetchingAssetMappingSucceeded(id, response));
    }
  } catch (error) {
    yield put(fetchingAssetMappingFailed(error));
  }
}

/*
* Delete PAPERFLITE asset uploads for storyboard
*/
export const deletePaperfliteAsset = createAction(DELETE_ASSET_REQUEST, (id) => {
  return id;
});

/*
* Delete asset mappings for storyboard
*/
export const deleteAssetMappings = createAction(DELETE_ASSET_MAPPINGS_REQUEST, (request) => {
  return request;
});

const deleteAssetMappingsSucceeded = createAction(DELETING_ASSET_MAPPINGS_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  };
});

const deleteAssetMappingsFailed = createAction(DELETING_ASSET_MAPPINGS_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  }
});

function* deleteAssetMappingsSaga(action) {
  const request = action.payload;

  const deleteAssetMappingsAPI = () => {
    return axios.post(`${ASSET_MAPPING_BASE_URL}/delete`, request).then(response => response.data);
  }

  try {
    const response = yield call(deleteAssetMappingsAPI);
    if (response) {
      yield put(deleteAssetMappingsSucceeded(request, response));
    }
  } catch (error) {
    yield put(deleteAssetMappingsFailed(request, error));
  }
}

/*
* Fetch preview for asset mapping
*/
export const fetchPreviewForAsset = createAction(FETCH_PREVIEW_FOR_ASSET_REQUEST, (id) => {
  return {
    id: id
  };
});

const fetchingPreviewForAssetSuccedded = createAction(FETCHING_PREVIEW_FOR_ASSET_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
});

const fetchingPreviewForAssetFailed = createAction(FETCHING_PREVIEW_FOR_ASSET_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchPreviewForAssetSaga(action) {
  const { id } = action.payload;

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: `/${id}/preview`
  });

  const fetchPreviewForAssetAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchPreviewForAssetAPI);
    if (response) {
      yield put(fetchingPreviewForAssetSuccedded(id, response));
      yield put(fetchPreviewTextForAsset(id));
    }
  } catch (error) {
    yield put(fetchingPreviewForAssetFailed(id, error));
  }
}

/*
* Fetch preview text for asset mapping
*/
export const fetchPreviewTextForAsset = createAction(FETCH_PREVIEW_TEXT_FOR_ASSET_REQUEST, (id) => {
  return {
    id: id
  };
});

const fetchingPreviewTextForAssetSuccedded = createAction(FETCHING_PREVIEW_TEXT_FOR_ASSET_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
});

const fetchingPreviewTextForAssetFailed = createAction(FETCHING_PREVIEW_TEXT_FOR_ASSET_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchPreviewTextForAssetSaga(action) {
  const { id } = action.payload;

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: `/${id}/preview/text`
  });

  const fetchPreviewTextForAssetAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchPreviewTextForAssetAPI);
    if (response) {
      yield put(fetchingPreviewTextForAssetSuccedded(id, response));
    }
  } catch (error) {
    yield put(fetchingPreviewTextForAssetFailed(id, error));
  }
}

/*
Fetch Duplicate Assets
*/

export const fetchDuplicateAssetsRequest = createAction(FETCH_DUPLICATE_ASSETS_REQUEST, (asset) => {
  let id = _.get(asset, 'asset.id');

  return {
    id: id,
    assetMapping: asset
  };
});

const fetchingDuplicateAssetsSucceeded = createAction(FETCHING_DUPLICATE_ASSETS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
});

const fetchingDuplicateAssetsFailed = createAction(FETCHING_DUPLICATE_ASSETS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchDuplicateAssetSaga(action) {
  const { id } = action.payload

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: '/duplicate-assets',
  });

  const storyboard = yield select(state => _.get(state, "storyboards.storyboard.item.id", null));

  var data = {
    asset: id,
    storyboard: storyboard
  }

  const fetchDuplicateAssetAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: data
    }).then(response => response.data);
  }

  try {
    const response = yield call(fetchDuplicateAssetAPI);
    if (response) {
      yield put(fetchingDuplicateAssetsSucceeded(id, response));
    }
  } catch (error) {
    yield put(fetchingDuplicateAssetsFailed(id, error));
  }
}

export const invalidateDuplicateAssets = createAction(INVALIDATE_DUPLICATE_ASSETS);


//Version Asset
export const uploadingAssetVersionStarted = createAction(UPLOADING_ASSET_VERSION_STARTED, (id, file) => {
  return {
    id: id,
    file: file
  }
})

export const uploadingAssetVersionProgress = createAction(UPLOADING_ASSET_VERSION_PROGRESS, (file, progress, id) => {
  return {
    progress: progress,
    file: file,
    id: id
  }
});

export const createAssetVersion = createAction(CREATE_ASSET_VERSION_REQUEST, (id, url, isUrlAsset) => {
  return {
    id: id,
    request: url,
    isUrlAsset: isUrlAsset
  }
})

const createAssetVersionSucceeded = createAction(CREATING_ASSET_VERSION_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const createAssetVersionFailed = createAction(CREATING_ASSET_VERSION_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* createAssetVersionSaga(action) {
  const { id, request, isUrlAsset } = action.payload;

  var data = {
    signedUrl: request
  }

  let url = buildUrl(ASSETS_BASE_URL, {
    path: `/${id}/version`
  });

  if(isUrlAsset){
    data = {
      asset: id,
      url: request
    }

    url = buildUrl(ASSET_MAPPING_BASE_URL, {
      path: `/${id}/version`
    });
  }

  const createAssetVersionFromAPI = () => {
    return axios.post(url, data).then(response => response.data);
  }

  try {
    const response = yield call(createAssetVersionFromAPI);
    if (response) {
      yield put(createAssetVersionSucceeded(id, response));
    }
  } catch (error) {
    yield put(createAssetVersionFailed(id, error));
  }
}

/*
* Update Asset mappings for contents
*/
export const updateAssetMappings = createAction(UPDATE_ASSET_MAPPINGS_REQUEST, (id, request, mappingRequest) => {
  return {
    id: id,
    request: request,
    mappingRequest: mappingRequest
  }
});

const updateAssetMappingsSucceeded = createAction(UPDATING_ASSET_MAPPINGS_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const updateAssetMappingsFailed = createAction(UPDATING_ASSET_MAPPINGS_FAILED, ( error) => {
  return {
    error: error
  }
});

function* updateAssetMappingsSaga(action) {
  const { id, request, mappingRequest } = action.payload;

  const params = {
    storyboard: id,
  };


  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: '/bulk',
    queryParams: params
  });

  const updateAssetMappingsAPI = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: request
    }).then(response => response.data);
  }

  try {
    const response = yield call(updateAssetMappingsAPI);
    if (response) {
      yield put(updateAssetMappingsSucceeded(response));
      yield put(fetchAssetMappings(mappingRequest, 0, 20));
    }
  } catch (error) {
    yield put(updateAssetMappingsFailed( error));
  }
}


/*
* Update Asset mapping for assets
*/
export const updateAssetMapping = createAction(UPDATE_ASSET_MAPPING_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  }
});

const updateAssetMappingSucceeded = createAction(UPDATING_ASSET_MAPPING_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  }
});

const updateAssetMappingFailed = createAction(UPDATING_ASSET_MAPPING_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  }
});

function* updateAssetMappingSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: `/${id}`
  });

  const updateAssetMappingAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateAssetMappingAPI);
    if (response) {
      yield put(updateAssetMappingSucceeded(request, response));
    }
  } catch (error) {
    yield put(updateAssetMappingFailed(request, error));
  }
}

/*
* Create Asset mapping for assets
*/
export const assetSeekIndexing = createAction(ASSET_SEEK_INDEXING_REQUEST, (request) => {
  return {
    request: request
  }
});

const assetSeekIndexingSucceeded = createAction(ASSET_SEEK_INDEXING_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  }
});

const assetSeekIndexingFailed = createAction(ASSET_SEEK_INDEXING_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  }
});

function* assetSeekIndexingSaga(action) {
  const { request } = action.payload;

  const seekIndexingAPI = () => {
    return axios.post(SEEK_INDEXING_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(seekIndexingAPI);
    if (response) {
      yield put(assetSeekIndexingSucceeded(request, response));
    }
  } catch (error) {
    yield put(assetSeekIndexingFailed(request, error));
  }
}


/*
* Invalidate asset mappings
*/
export const invalidateAssetMappings = createAction(INVALIDATE_ASSET_MAPPINGS);

/*
* Invalidate asset uploaded
*/
export const invalidateAssetUploaded = createAction(INVALIDATE_ASSET_UPLOADED);


/* 
* Filters, Sort & Search Queries
*/

// Search Dropdown Asset Mappings
export const fetchAssetMappingsOnSearch = createAction(FETCH_ASSET_MAPPINGS_ON_SEARCH_REQUEST, (request, page, limit = 20) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
})

const fetchAssetMappingsOnSearchSucceeded = createAction(FETCHING_ASSET_MAPPINGS_ON_SEARCH_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  };
})

const fetchAssetMappingsOnSearchFailed = createAction(FETCHING_ASSET_MAPPINGS_ON_SEARCH_FAILED, (error) => {
  return error;
})

function* fetchAssetMappingsOnSearchSaga(action) {
  const { request, page, limit } = action.payload;

  const params = {
    page: page,
    limit: limit
  };

  let url = buildUrl(ASSET_MAPPING_BASE_URL, {
    path: 'search',
    queryParams: params
  });

  const fetchAssetMappingsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchAssetMappingsAPI);
    if (response) {
      yield put(fetchAssetMappingsOnSearchSucceeded(request, response));
    }
  } catch (error) {
    yield put(fetchAssetMappingsOnSearchFailed(error));
  }
}

/*
* Update Filters & Sort
*/
export const updateFilterSortInContentManager = createAction(UPDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER, (request) => {
  return {
    request: request
  }
})

export const invalidateFilterSortInContentManager = createAction(INVALIDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER)

/*
* Invalidate Search Asset Mappings
*/
export const invalidateSearchAssetMappings = createAction(INVALIDATE_SEARCH_ASSET_MAPPINGS);

/*
* Upload Storyboard page as asset
*/

export const uploadStoryboardPage = createAction(UPLOAD_ASSET_REQUEST, (asset)=>{
  return {
    asset: asset
  }
})

export const removeSelectedPage = createAction(REMOVE_ASSET_REQUEST, (asset)=>{
  return {
    asset: asset
  }
})

export default function* contentSaga() {
  yield takeEvery(CREATE_CONTENT_REQUEST, createContentSaga);
  yield takeEvery(UPDATE_MULTIPLE_ASSETS_CONTENT, updateMultipleContentSaga);
  yield takeEvery(ADD_ASSET_URL, createAssetFromUrlSaga);
  yield takeEvery(CREATE_ASSET_MAPPING_REQUEST, createAssetMappingSaga);
  yield takeEvery(FETCH_ASSET_MAPPINGS_REQUEST, fetchAssetMappingsSaga);
  yield takeEvery(FETCH_ASSET_MAPPING_REQUEST, fetchAssetMappingSaga);
  yield takeEvery(DELETE_ASSET_REQUEST, deletePaperfliteAsset);
  yield takeEvery(DELETE_ASSET_MAPPINGS_REQUEST, deleteAssetMappingsSaga);
  yield takeEvery(FETCH_PREVIEW_FOR_ASSET_REQUEST, fetchPreviewForAssetSaga);
  yield takeEvery(FETCH_PREVIEW_TEXT_FOR_ASSET_REQUEST, fetchPreviewTextForAssetSaga);
  yield takeEvery(UPDATE_ASSET_MAPPING_REQUEST, updateAssetMappingSaga);
  yield takeEvery(ASSET_SEEK_INDEXING_REQUEST, assetSeekIndexingSaga);
  yield takeEvery(UPDATE_ASSET_MAPPINGS_REQUEST, updateAssetMappingsSaga);
  yield takeEvery(FETCH_DUPLICATE_ASSETS_REQUEST, fetchDuplicateAssetSaga);
  yield takeEvery(CREATE_ASSET_VERSION_REQUEST, createAssetVersionSaga);
  yield takeEvery(FETCH_ASSET_MAPPINGS_ON_SEARCH_REQUEST, fetchAssetMappingsOnSearchSaga);
};
